import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const FormField = ({
  placeholder,
  iconComponent,
  styles,
  gridOptions,
  children
}) => {
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: gridOptions.flex.direction,
    justify: gridOptions.flex.justify,
    className: styles.inputRow
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: gridOptions.placeholder.xs,
    sm: gridOptions.placeholder.sm
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.label
  }, iconComponent, placeholder)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: gridOptions.input.xs,
    sm: gridOptions.input.sm
  }, children));
};

export default FormField;